const roleNameConstants = {
  owner: 'owner',
  reimbursifyLeadPractitioner: 'reimbursify-lead-practitioner',
  reimbursifyPractitioner: 'reimbursify-practitioner',
  reimbursifyAdministrator: 'reimbursify-administrator',
};

export default roleNameConstants;
